module.exports = __webpack_public_path__ + "img/settings.1bb3c31a.svg";